import { render } from "./LcRemarks.vue?vue&type=template&id=3ad3f238&scoped=true"
import script from "./LcRemarks.vue?vue&type=script&lang=js"
export * from "./LcRemarks.vue?vue&type=script&lang=js"

import "./LcRemarks.vue?vue&type=style&index=0&id=3ad3f238&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad3f238"]])

export default __exports__